<template>
<div>
    <!-- modal -->
    <b-modal id="matterFinalizationFormModal" ref="matterFinalizationFormModal" centered size="lg" no-close-on-backdrop :title=" $t('matterFinalization.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <b-row>
            <b-col class="col-lg-6">
                <label for="matter-finalization-is-finalized-input">{{ $t('matterFinalization.is_finalized') }}</label>
                <b-form-checkbox class="custom-control-success" name="matter-finalization-is-finalized-input" id="matter-finalization-is-finalized-input" v-model="isFinalized" switch>
                    <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon" />
                    </span>
                    <span class="switch-icon-right">
                        <feather-icon icon="XIcon" />
                    </span>
                </b-form-checkbox>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label for="matter-finalization-date-input">{{ $t('matterFinalization.date') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('matterFinalization.date')" size="sm" v-model="date" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
    </b-modal>
</div>
</template>

  
<script>
export default {
    props: {
        getMatterFinalizationList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId:0,
            isFinalized: false,
            date: null,
        }
    },
    methods: {
        showInfo(id, lawMatterId) {
            this.$refs['matterFinalizationFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterFinalization'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.isFinalized = response.data.lawMatterFinalization.isFinalized
                    this.date = response.data.lawMatterFinalization.date
                } else {
                    this.$bvModal.hide('matterFinalizationFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                isFinalized: this.isFinalized,
                date: this.date,
                lawMatterId : this.lawMatterId    

            }
            const controller = {
                name: 'LawMatterFinalization'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$bvModal.hide('matterFinalizationFormModal')
                    this.getMatterFinalizationList()
                    this.$SaveAlert()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
